import { MinimalProgressBar } from "@circle-react-uikit/MinimalProgressBar";
import { Typography } from "@circle-react-uikit/Typography";

interface UsageMetricProps {
  description: string;
  price?: string;
  progress: number;
  title: string;
}

export const UsageMetric = ({
  title,
  progress,
  description,
  price,
}: UsageMetricProps) => (
  <div className="flex flex-col gap-1">
    <Typography.LabelSm weight="medium">{title}</Typography.LabelSm>
    <div className="flex items-center justify-between gap-x-3">
      <MinimalProgressBar progress={progress} />
      {price && <Typography.BodySm>{price}</Typography.BodySm>}
    </div>
    <Typography.BodySm color="text-default">{description}</Typography.BodySm>
  </div>
);
